import { Action } from '@weblite/logic-toolkit'
import {
  DEFAULT_OPEN_LIST_TYPE,
  OpenedUserListItem,
  openedUserListStorage,
} from './storage'

export const openedUserListRefetchAction = new Action<string>()

export function removeFromOpenedUserList(
  userId: string,
  key = DEFAULT_OPEN_LIST_TYPE,
) {
  openedUserListStorage.remove(userId, key)
}

export function removeAdminFromOpenedUserList(
  userId: string,
  key = DEFAULT_OPEN_LIST_TYPE,
) {
  openedUserListStorage.modify({ id: userId, admin: false }, key)
}

export function AddToOpenedUserList(
  users: OpenedUserListItem[],
  key = DEFAULT_OPEN_LIST_TYPE,
) {
  openedUserListStorage.insertBatch(users, key)
}

export function resetOpenedUserList(
  key = DEFAULT_OPEN_LIST_TYPE,
  invokeRefetch = true,
) {
  openedUserListStorage.reset(key)
  if (invokeRefetch) openedUserListRefetchAction.invoke(key)
}

export function resetOpenedUserListSearch(key = DEFAULT_OPEN_LIST_TYPE) {
  openedUserListStorage.resetSearch(key)
}
